import React from "react";
import isEqual from "lodash/isEqual";
import { AbacProvider } from "react-abac";
import { useSelector } from "react-redux";
import { RootState } from "../redux/rootReducer";
import { IRole, Role } from "../types/IRole";
import { ITeam, TeamRole } from "../types/ITeam";
import { IUser } from "../types/IUser";
import { IProposal } from "../types/IProposal";

export enum Permission {
  PUBLISH_PROPOSAL = "PUBLISH_PROPOSAL",
  DELETE_PROPOSAL = "DELETE_PROPOSAL",
  MODERATE_PROPOSAL = "MODERATE_PROPOSAL",
  ADMINISTRATE_TEAM = "ADMINISTRATE_TEAM",
  VIEW_PROPOSAL = "VIEW_PROPOSAL",
}

export const rules = {
  [Role.SYSTEM_ADMIN]: {
    [Permission.DELETE_PROPOSAL]: true,
    [Permission.MODERATE_PROPOSAL]: true,
    [Permission.VIEW_PROPOSAL]: (proposal, _) => {
      const isPublished = proposal?.isPublished;

      return isPublished;
    },
  },
  [Role.USER]: {},
  [Role.MODERATOR]: {
    [Permission.DELETE_PROPOSAL]: true,
    [Permission.MODERATE_PROPOSAL]: true,
    [Permission.VIEW_PROPOSAL]: (proposal, _) => {
      const isPublished = proposal?.isPublished;

      return isPublished;
    },
  },
  [Permission.PUBLISH_PROPOSAL]: (proposal: IProposal, user?: IUser) => {
    if (!proposal) return false;

    const isPublished = proposal.isPublished;

    return (
      !isPublished &&
      user &&
      user.userTeams.some(
        (ut) =>
          isEqual(ut.teamId, proposal.teamId) &&
          isEqual(ut.teamRole, TeamRole.ADMIN)
      )
    );
  },
  [Permission.VIEW_PROPOSAL]: (proposal: IProposal, user?: IUser) => {
    return (
      user &&
      proposal &&
      user.userTeams.some((ut) => isEqual(ut.teamId, proposal.teamId))
    );
  },
  [Permission.ADMINISTRATE_TEAM]: (team: ITeam, user?: IUser) => {
    const teamUser = team?.teamUsers?.find((teamUser) => {
      if (user.id === teamUser.userId) {
        return isEqual(teamUser.teamRole, TeamRole.ADMIN);
      }

      return false;
    });

    return isEqual(teamUser?.teamRole, TeamRole.ADMIN);
  },
};

export const ConnectedAbacProvider = ({ children }) => {
  const { user }: { user?: IUser } = useSelector(({ auth }: RootState) => ({
    user: auth.user,
  }));

  const roles = (user?.roles || []).map((r: IRole) => r.value);

  return (
    <AbacProvider
      rules={rules}
      user={user}
      roles={roles}
      permissions={[
        Permission.PUBLISH_PROPOSAL,
        Permission.DELETE_PROPOSAL,
        Permission.ADMINISTRATE_TEAM,
        Permission.VIEW_PROPOSAL,
      ]}
    >
      {children}
    </AbacProvider>
  );
};
